import { render, staticRenderFns } from "./loginSideBarWestudy.vue?vue&type=template&id=37180ed0&scoped=true&"
import script from "./loginSideBarWestudy.vue?vue&type=script&lang=js&"
export * from "./loginSideBarWestudy.vue?vue&type=script&lang=js&"
import style0 from "./loginSideBarWestudy.vue?vue&type=style&index=0&id=37180ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37180ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VOverlay,VSheet})
